export const videoUploadModalTranslationJP = {
  VideoUploadModal: {
    title: '画面詳細',
    close: '閉じる',
    delete: '削除',
    current_video: '現在の動画',
    re_upload: '再アップロード',
    file_selection: 'ファイル選択',
    reflect: '反映',
    upload_confirmation: 'アップロード確認',
    warn_confirm_delete: '削除しますか？',
    warn_upload_file_format: '有効な動画ファイル形式を選択してください（mp4などが使用可能です)',
    warn_upload_filesize: '{0}MBサイズ以下のファイルにしてください',
  },
};
